import { Accordion, AccordionDetails } from "@mui/material";
import { ClientPassportAccordionHeader } from "./ClientPassportAccordionHeader";

export const PassportAccordionItem = (props) => {
    const { title, onAddClick = () => {}, children, showAddButton = true } = props;
    return (
        <Accordion defaultExpanded elevation={0} sx={{ bgcolor: "whitesmoke" }}>
            <ClientPassportAccordionHeader
                title={title}
                onAddClick={onAddClick}
                showAddButton={showAddButton}
            />
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};
